export const initializeCartAddSelect = () => {
    const weightToggleEl = document.querySelector(".js-product-main .c-cart-add__toggle");

    for (const cartAddEl of document.querySelectorAll("r-tabs.js-cart-add")) {
        if (cartAddEl.classList.contains("is-cart-add-initialized")) continue;

        cartAddEl.addEventListener("rTab.after.openTab", (event) => {
            const currentCartAddEl = event.currentTarget;
            const productMainEl = currentCartAddEl.closest(".js-product-main");
            const productThumbEl = currentCartAddEl.closest(".js-thumb");
            const cartId = currentCartAddEl.activeTabs[0];
            const currentSelectEl = currentCartAddEl.querySelector(".js-cart-add-select");

            if (cartAddEl.id === "main-info-cart") {
                const fixedToggleEl = document.querySelector("#mobile-fixed-cart");

                if (fixedToggleEl && !fixedToggleEl.activeTabs.includes(cartId)) {
                    fixedToggleEl.openTab(cartId);
                }
            }

            if (cartAddEl.id === "mobile-fixed-cart") {
                const mainToggleEl = document.querySelector("#main-info-cart");

                if (mainToggleEl && !mainToggleEl.activeTabs.includes(cartId)) {
                    mainToggleEl.openTab(cartId);
                }
            }

            if (currentSelectEl) {
                currentSelectEl.value = cartId;
            }

            if (productMainEl) {
                for (const productPricingEl of productMainEl.querySelectorAll(
                    ".js-product-price"
                )) {
                    productPricingEl.classList.toggle(
                        "hidden",
                        productPricingEl.dataset.cartId !== cartId
                    );
                }
            }

            if (productThumbEl) {
                for (const productPricingEl of productThumbEl.querySelectorAll(
                    ".js-product-thumb-price"
                )) {
                    productPricingEl.classList.toggle(
                        "hidden",
                        productPricingEl.dataset.cartId !== cartId
                    );
                }
            }
        });

        const selectEl = cartAddEl.querySelector(".js-cart-add-select");
        if (selectEl) {
            selectEl.addEventListener("change", (event) => {
                cartAddEl.openTab(event.currentTarget.value);
            });
        }

        cartAddEl.classList.add("is-cart-add-initialized");
    }
};
